import defaultClient from '@src/api/clients/default';

export function fetchClientOffers(params = {}) {
  return defaultClient.request({
    url: 'dashboard/client-offers/',
    method: 'GET',
    payload: params,
  });
}

export function createClientOffer(payload) {
  return defaultClient.request({
    url: 'dashboard/client-offers/',
    method: 'POST',
    payload,
  });
}

export function updateClientOffer(id, payload) {
  return defaultClient.request({
    url: `dashboard/client-offers/${id}/`,
    method: 'PATCH',
    payload,
  });
}

export function deleteClientOffer(id) {
  return defaultClient.request({
    url: `dashboard/client-offers/${id}/`,
    method: 'DELETE',
  });
}

export function fetchClientOfferOptions(params = {}) {
  return defaultClient.request({
    url: 'dashboard/client-offers/options/',
    method: 'GET',
    payload: params,
  });
}

export function createClientOfferOption(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-offers/options/',
    method: 'POST',
    payload,
  });
}
